<div #canvasContainer id="canvas-container"></div>